export default "__VITE_ASSET__fccd662a__"